import { STKContainer, STKRow, STKCol } from "@/components/common/grid";
import WillEditorInput from "../components/input";
import STKAnimated from "@/components/common/animated";
import { fieldLabels, viewHeadings } from "../will-editor";
import { PageContentField } from "@/providers/content-provider";

const WillEditorView1 = () => {

    return(
        <STKAnimated key={1} type="down-to-up">
            <PageContentField section={'view-1'} index={0} />
            <h6>{viewHeadings[0]}</h6>
            <STKContainer>
                <STKRow gutterX={1.6} gutterY={1.6}>

                    <STKCol xs={100} sm={100} md={58.3333} lg={58.3333}>
                        <WillEditorInput name="name" label={fieldLabels['name']} validate="required" />
                    </STKCol>
                    <STKCol xs={100} sm={100} md={41.6666} lg={41.6666}>
                        <WillEditorInput name="ssn" label={fieldLabels['ssn']} validate="required" />
                    </STKCol>

                    <STKCol xs={100} sm={100} md={58.3333} lg={58.3333}>
                        <WillEditorInput name="city" label={fieldLabels['city']} validate="required" />
                    </STKCol>
                    <STKCol xs={100} sm={100} md={41.6666} lg={41.6666}>
                        <WillEditorInput name="postalCode" label={fieldLabels['postalCode']} validate="required" />
                    </STKCol>

                    <STKCol xs={100} sm={100} md={100} lg={100}>
                        <WillEditorInput name="address" label={fieldLabels['address']} validate="required" />
                    </STKCol>

                    <STKCol xs={100} sm={100} md={100} lg={100}>
                        <WillEditorInput name="email" label={fieldLabels['email']} validate="required|email" /> 
                    </STKCol>

                    <STKCol xs={100} sm={100} md={100} lg={100}>
                        <WillEditorInput name="phone" label={fieldLabels['phone']} validate="required|phone2" /> 
                    </STKCol>

                </STKRow>
            </STKContainer>
            
        </STKAnimated>
    );

}

export default WillEditorView1;
